import { render, staticRenderFns } from "./UCSACourseList.vue?vue&type=template&id=57871493&"
import script from "./UCSACourseList.vue?vue&type=script&lang=js&"
export * from "./UCSACourseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports